import { Moment } from 'moment';
import * as moment from 'moment';

export function mapDateOfBirthToAge(dateOfBirth: Moment): number {
  return moment().diff(dateOfBirth, 'years');
}

export function combineMomentDateAndTimeSpan(date: Moment, time: string): Moment {
  const split = time.split(':'); 

  let offset: number = date.clone().utcOffset();
  let value = date.clone().utc(false).minutes(offset).add({  
    hours: +split[0],
    minutes: +split[1]
  });

  let compareWithPreviousDSTWinter = value.clone().subtract(1, 'day').isDST() == true && value.isDST() == false;
  let compareWithPreviousDSTSummer = value.clone().subtract(1, 'day').isDST() == false && value.isDST() == true;

  if(compareWithPreviousDSTWinter) {
    value.add(1, 'hour');
  } else if (compareWithPreviousDSTSummer) {
    value.subtract(1, 'hour');
  }

  return value;
}

export function isNullOrWhitespace(input) {
  return !input || !input.trim();
}